module.exports = __webpack_public_path__ + "static/media/certifications_udemy_2021_flutter_development.426f400b.png";